;(function () {
  'use strict'

  angular.module('contrast.highcharts').constant('HIGHCHARTS_CHART_TYPES', {
    AREA: 'area',
    SCATTER: 'scatter',
    COLUMN: 'column'
  })
})()
